var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ds-component-info" }, [
    _c("p", [
      _c(
        "label",
        { staticStyle: { width: "100px", display: "inline-block" } },
        [_vm._v("控件类型：")]
      ),
      _vm._v(" " + _vm._s(_vm.info.caption) + " "),
    ]),
    _c("p", [
      _c(
        "label",
        { staticStyle: { width: "100px", display: "inline-block" } },
        [_vm._v("元数据标识：")]
      ),
      _vm._v(" " + _vm._s(_vm.info.id || "无") + " "),
    ]),
    _c("p", [
      _c(
        "label",
        { staticStyle: { width: "100px", display: "inline-block" } },
        [_vm._v("元数据名称：")]
      ),
      _vm._v(" " + _vm._s(_vm.info.name || "无") + " "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }